import N8nFormInputs from './FormInputs.vue';

export default N8nFormInputs;
